<template>
    <label class="checkbox_custom" @click.prevent="clickCheckbox">
        <input type="checkbox" :checked="checkboxState" v-model="checkboxData" class="checkbox_custom_input">
        <div class="checkbox_custom_checkbox">
            <svg>
                <use :xlink:href="'/icons/base.svg#' + checkState"></use>
            </svg>
        </div>

        <div v-if="isCheckboxLabel" class="checkbox_custom_label">{{ checkboxLabel }}</div>
    </label>
</template>

<script>

export default {
    name: "checkbox_custom",
    props: {
        checkboxLabel: {
            type: String,
            required: false,
        },
        checkboxState: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['click_checkbox_custom'],
    data() {
        return {
            checkboxData: false,
        }
    },
    beforeMount() {
        this.checkboxData = this.checkboxState;
    },
    methods: {
        clickCheckbox() {
            this.$emit('click_checkbox_custom');
        },
    },
    computed: {
        isCheckboxLabel() {
            if (this.checkboxLabel && this.checkboxLabel !== '') {
                return true;
            }
            return false;
        },
        checkState() {
            if (this.checkboxState) {
                return 'mark';
            }
            return 'unmark';
        },
    },
}
</script>
